// src/components/OptionsModal/OptionsModal.jsx
import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import UiPropsModal from '../UiPropsModal/UiPropsModal';
import ProfileModal from '../ProfileModal/ProfileModal';
import styles from './OptionsModal.module.css';

const OptionsModal = ({ onClose }) => {
  const { logout } = useAuth();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showUiPropsModal, setShowUiPropsModal] = useState(false);

  return (
    <>
      <div className={styles.overlay} onClick={onClose}>
        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
          <h3>Einstellungen</h3>

          <button className={styles.option} onClick={() => setShowProfileModal(true)}>
            Profil bearbeiten
          </button>

          <button
            className={styles.option}
            onClick={() => setShowUiPropsModal(true)}
          >
            UI Einstellungen
          </button>

          <button className={styles.logout} onClick={logout}>
            Abmelden
          </button>
        </div>
      </div>

      {showProfileModal && <ProfileModal onClose={() => setShowProfileModal(false)} />}
      {showUiPropsModal && <UiPropsModal onClose={() => setShowUiPropsModal(false)} />}
    </>
  );
};

export default OptionsModal;